import { render, staticRenderFns } from "./Weekdays.vue?vue&type=template&id=04406ae2&scoped=true&"
import script from "./Weekdays.vue?vue&type=script&lang=js&"
export * from "./Weekdays.vue?vue&type=script&lang=js&"
import style0 from "./Weekdays.vue?vue&type=style&index=0&id=04406ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04406ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VBtn,VBtnToggle,VMessages})
